import { AppPalette } from '../../colors'

export const MuiCard = {
  styleOverrides: {
    root: {
      border: `1px solid ${AppPalette.BORDER.dark}`,
      boxShadow: 'none',
      padding: '16px',
    },
  },
}
